import { NewsList } from "@/components/News/NewsList";
import { getBundesligaNews } from "@/data/news";
import { News } from "@/models/types";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { Footer } from "../../../components/Footer";
import { PlayersList } from "../../../components/Players/PlayersList";
import { Nav } from "../../../components/common/FrontendNav";
import { getCurrentBundesligaPlayers } from "../../../helper/api";
import { LeaguePlayerWithTeam } from "../../../models/LeaguePlayer";
import { setGhostCacheHeader } from "@/helper/cacheHeaders";

export async function getServerSideProps(context: any) {
  const { res } = context;
  setGhostCacheHeader(res);
  const players = await getCurrentBundesligaPlayers({});

  const { news } = await getBundesligaNews({
    locale: context.locale,
  });

  return {
    props: {
      players,
      news,
      ...(await serverSideTranslations(context.locale)),
    },
  };
}

interface BundesligaPlayerPageProps {
  players: LeaguePlayerWithTeam[];
  news: News[];
}
export default function BundesligaPlayerPage({
  players,
  news,
}: BundesligaPlayerPageProps) {
  return (
    <div>
      <Nav />
      <div className="container ">
        <PlayersList players={players} baseUrl={`/bundesliga/players`} />
      </div>
      {news.length > 0 && (
        <div className="container container_py">
          <NewsList news={news} title="Bundesliga News" type="bundesliga" />
        </div>
      )}
      <Footer />
    </div>
  );
}
